import scrollToElement from "../common/helpers/scrollToElement";
import {Logger} from "~/services/logger";

export default (event, payload) => {
  Logger.log("scrolling to hash");
  if (payload.hash) {
    const $container = payload.container ? $(payload.container) : $('body');
    const $target = $(payload.hash);
    $(document).promise().then(() => {
      scrollToElement({
        $el: $target,
        $container: $container,
        offset: -200
      })
    }).done(() => {
      $target.trigger('focus');
    })
  }
};